import { useQuery } from '@tanstack/react-query';
import { useHistory } from 'react-router-dom';
import { axios } from '~/root';
import { qk } from '~/root/query-keys';

export const useValidateToken = (token: string) => {
  const history = useHistory();

  return useQuery({
    queryKey: qk.createPasswordValidate,
    queryFn: () => {
      return axios.get(`/v1/users/verify/create-password/${token}`).catch((error) => {
        if (error?.response?.data?.status === 'error') {
          history.replace('/');
        }
        throw error;
      });
    },
  });
};
